import { DeleteOutlineIcon } from '@carboncopyco/icons';
import type { Tag } from '@carboncopyco/types';
import {
  Button,
  Checkbox,
  ConfirmAlert,
  List,
  ScrollContainer,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import { useState } from 'react';

import { useWorkspaceManageTag } from './WorkspaceManageTagContext';
import { WorkspaceManageTagLabel } from './WorkspaceManageTagLabel';
import { WorkspaceManageTagListRowWrapper } from './WorkspaceManageTagListRowWrapper';
import { WorkspaceManageTagListSkeleton } from './WorkspaceManageTagListSkeleton';

export const WorkspaceManageTagList = () => {
  const { deleteTag, isLoading, list, selectedTags, isLoadingDeleteTag } =
    useWorkspaceManageTag();
  const [deletedTag, setDeletedTag] = useState<Tag>(null);
  return (
    <div
      className={classNames('w-full max-h-[218px] overflow-hidden', {
        'h-[218px]': list.length > 5,
      })}
    >
      <ScrollContainer bottomOffset={20}>
        {isLoading ? (
          <WorkspaceManageTagListSkeleton />
        ) : (
          <List<Tag>
            noSpacing
            data={list}
            renderItem={(item) => (
              <WorkspaceManageTagListRowWrapper item={item}>
                <div className="flex items-center justify-between w-full">
                  <div className="flex gap-2 items-center justify-center">
                    <Checkbox
                      name={item.name ?? item['workspaceName']}
                      checked={selectedTags.has(item.id)}
                      onChange={(event) => {
                        selectedTags.has(event.target.value)
                          ? selectedTags.delete(event.target.value)
                          : selectedTags.add(event.target.value);
                      }}
                    />

                    <WorkspaceManageTagLabel {...item} />
                  </div>
                  <div className="text-ds-natural-300 invisible group-hover:visible">
                    <Button
                      color="text-ds-natural-300"
                      link
                      icon={<DeleteOutlineIcon color="#999" />}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setDeletedTag(item);
                      }}
                    />
                  </div>
                </div>
              </WorkspaceManageTagListRowWrapper>
            )}
          />
        )}
      </ScrollContainer>
      {deletedTag && (
        <ConfirmAlert
          disabled={isLoadingDeleteTag}
          loading={isLoadingDeleteTag}
          title="Delete tag?"
          description={`Are you sure you want to delete ${deletedTag.name} tag? This tag will be removed from all associated workspaces.`}
          show={!!deletedTag}
          onConfirm={() => {
            deleteTag(deletedTag.id);
            setDeletedTag(null);
          }}
          onClose={() => setDeletedTag(null)}
          danger
          containerClass="w-ds-normal-modal"
          yesIcon={<DeleteOutlineIcon />}
          yesLabel="Delete"
        />
      )}
    </div>
  );
};
